<div class="form-group" [ngClass]="{ 'has-error': showError }" [attr.qa-id]="field.key">
	<label *ngIf="to.label" [ngClass]="{ 'sr-only': to.hideLabel }" [attr.for]="id">
		{{ to.label }}
		<span *ngIf="!to.required && !to.hideRequiredMarker">({{ 'optional' | translate }})</span>
	</label>
	<div [ngClass]="{ 'form-group-field__has-tooltip': !!to.tooltipMessage && field.type !== FieldType.SWITCH }">
		<div class="form-group-field">
			<ng-template #fieldComponent></ng-template>
		</div>
		<span
			class="info-tooltip def-focus"
			tabindex="0"
			role="button"
			[title]="'lup.a11y.info_tab' | translate"
			*ngIf="!!to.tooltipMessage && field.type !== FieldType.SWITCH"
			(click)="openTooltip()">
			<lu-icon icon="info-circle"></lu-icon>
		</span>
	</div>
	<div
		class="char-left__info"
		*ngIf="
			to.maxLengthMessage &&
			(!to.maxLengthLimit || (this.formControl.value | charactersLeft: to.maxLength) <= to.maxLengthLimit)
		">
		{{
			(this.formControl.value | charactersLeft: to.maxLength) === 1
				? ('lup.settings.promo_banners_settings.char_left.one' | translate)
				: ('lup.settings.promo_banners_settings.char_left.other'
					| translate: { count: (this.formControl.value | charactersLeft: to.maxLength) })
		}}
	</div>
	<div class="form-validation">
		<div
			class="form-validation__error invalid-feedback"
			[ngClass]="{ invisible: !showError, 'invalid-feedback--left': to.errorPosition === ErrorPosition.LEFT }">
			<formly-validation-message [field]="field" role="alert"></formly-validation-message>
		</div>
	</div>
	<p [ngClass]="{ invisible: !to.description }" class="form-description message" *ngIf="to.description">
		{{ to.description }}
	</p>
</div>
